import useInput from '../../hooks/use-input';
import { Keyword } from '../../types/Keyword';

type PaperKeywordsProps = {
  keywords: Keyword[];
  addKeywordToPaper?: (repoId: string, paperId:string, keyword: string) => Promise<void>;
  removeKeywordFromPaper?: (repoId: string, paperId:string, keywordId: string) => Promise<void>;
  repoId: string;
  paperId: string;
}

const PaperKeywords = (props: PaperKeywordsProps) => {
  const { value: keyword, valueChangeHandler: keywordChangeHandler, inputBlurHandler: keywordBlurHandler, reset: resetKeyword } = useInput('');

  const handleKeyDown = (event:any) => {
    if(event.keyCode === 13){
      if(props.addKeywordToPaper && keyword.trim() !== ''){
        props.addKeywordToPaper(props.repoId ,props.paperId, keyword)
        resetKeyword();
      }
   }
  }

  const removeKeywordHandler = (keywordId: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if(props.removeKeywordFromPaper){
      props.removeKeywordFromPaper(props.repoId, props.paperId, keywordId);
    }
  }

  return (
    <div className="row mb-3">
      <div className="col-md-12">
        <span className="title-top">Keywords</span>
        <div className="keywords-list">
          {/* <form id="form"> */}
            {/* <input id="form-tags-1" name="tags-1" type="text" {...bindKeywords} /> */}


            <div id="form-tags-1_tagsinput" className="tagsinput">
              {props.addKeywordToPaper &&
              <div id="form-tags-1_addTag">
                <input id="form-tags-1_tag" onKeyDown={(e) =>handleKeyDown(e)} className="tag-input" value={keyword}
              onChange={keywordChangeHandler}
              onBlur={keywordBlurHandler} placeholder="Type to add new keyword" autoComplete="off" />
              </div>}


              {props.keywords &&
                props.keywords.map((keyword, index) => <span className="tag" key={index}>
                <span className="tag-text">{keyword.keyword}</span>
                <button className="tag-remove" onClick={(e) => removeKeywordHandler(keyword.id)(e)}></button>
              </span>)
              }

            </div>
          {/* </form> */}
        </div>
      </div>
    </div>
  );
}

export default PaperKeywords;
